var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
        'show-grid-block',
        _vm.scroll && 'show-grid-block-scroll',
        _vm.scrollMobileOnly && 'show-grid-block-scroll-mobile-only',
        _vm.padded && 'show-grid-block-padded',
    ]},_vm._l((_vm.shows),function(show,index){return _c('div',{key:show.id + index,staticClass:"tile"},[_c(_setup.ShowGridTile,{attrs:{"show":show}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }